// libs
import { MdDone } from "react-icons/md";
import { TiInfoLarge } from "react-icons/ti";
import { GoAlert } from "react-icons/go";
import { IoClose } from "react-icons/io5";

// constants
import alertTypes from "../../constants/alertTypes";

// styles
import classes from "./styles.module.css";

export default function Alert({ data }) {
  const {
    // id,
    msg,
    type,
  } = data;

  const typesIcons = {
    [alertTypes.ERROR]: <IoClose size={20} />,
    [alertTypes.INFO]: <TiInfoLarge size={20} />,
    [alertTypes.SUCCESS]: <MdDone size={20}/>,
    [alertTypes.WARNING]: <GoAlert size={18} />,
  };

  return (
    <div className={`${classes.root} ${classes[type]}`}>
      <div className={classes.icon}>
        {typesIcons[type]}
      </div>

      <div>
        {msg}
      </div>
    </div>
  );
}
